import { SignInButton } from "./SignInButton";
import ErrorMessage from "../generic_components/ErrorMessage";

function LoginError() {
  return (
    <div className="padding-container">
      <center>
        <h4>Sign in to access SIM Documents</h4>
        <SignInButton />
        <ErrorMessage
          errors={[
            "Oops, it seems like you don't have access to this page. Please contact service desk IT.",
          ]}
        />
      </center>
    </div>
  );
}

export default LoginError;
